import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { Space } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../utils';
import {  Swiper } from 'antd-mobile';
import { Content2DataSource } from '../data';

class Content2 extends React.PureComponent {
  render() {
    const {  isMobile, ...props } = this.props;
    const dataSource = Content2DataSource;
    const {
      wrapper,
      page,
      OverPack: overPackData,
      childWrapper,
    } = dataSource;

    const renderPC = (childWrapper) => {
      return (<Space {...page}>
        {childWrapper.children.map((block, i) => {
          const { children: item, ...blockProps } = block;
          return (
            <OverPack {...overPackData}>
              <QueueAnim
                type="bottom"
                key="block"
                leaveReverse
                component={'div'}
                componentProps={childWrapper}
              >
                <div style={{
                  background: `url(${item.bgImg}) top/cover no-repeat`,
                }}
                  key={i.toString()}
                  {...blockProps}>
                  <div
                    {...item}
                  >
                    {item.children.map(getChildrenToRender)}
                  </div>
                </div>
              </QueueAnim>
            </OverPack>
          );
        })}

      </Space>)
    }

    const renderMobile = (childWrapper) => {
      const { children } = childWrapper;
      return (<Swiper>
        {children.map((block, i) => {
          const { children: item, ...blockProps } = block;
          return (<Swiper.Item key={i}>
            <div style={{
              background: `url(${item.bgImg}) top/cover no-repeat`,
            }}
              key={i.toString()}
              {...blockProps}>
              <div
                {...item}
              >
                {item.children.map(getChildrenToRender)}
              </div>
            </div>
          </Swiper.Item>)
        } )}
      </Swiper>)
    }
    return (
      <div {...props} {...wrapper}>
        {isMobile ? renderMobile(childWrapper) : renderPC(childWrapper)}

      </div>
    );
  }
}

export default Content2;
